export const actionTypePrefix = '@@EmoteSelector';
export const reduxKey = '@@EmoteSelector';

//# sourceMappingURL=constants.js.map